// ui-sref, kas overridēts ar
angular.module("myApp").directive("ctxSref", (authentication, $state) => {
  const parseStateRef = (ref) => {
    // taken from ui-router and slightly adjusted

    const parsed = ref.replace(/\n/g, " ").match(/^\s*([^(]*?)\s*(\((.*)\))?\s*$/)
    if (!parsed || parsed.length !== 4) throw new Error(`Invalid state ref '${ref}'`)

    return {
      state: parsed[1],
      params: parsed[3] || `{}`,
    }
  }

  const link = (scope, element, attrs) => {
    element.css("cursor", "pointer")

    if (element[0].nodeName.toLowerCase() === "a") {
      const updateHref = () => {
        const ref = parseStateRef(attrs.ctxSref)
        const params = scope.$eval(ref.params)
        params.context = authentication.u.context
        const href = $state.href(ref.state, params)
        if (href) {
          element[0].href = href
          return true
        }
        element[0].href = ""
        return false
      }

      if (updateHref()) {
        scope.$on("context-changed", updateHref)
        return
      }
    }

    return element.click((ev) => {
      ev.preventDefault()
      const ref = parseStateRef(attrs.ctxSref)
      const params = scope.$eval(ref.params)
      params.context = authentication.u.context
      return $state.go(ref.state, params)
    })
  }
  return {
    restrict: "A",
    link: link,
  }
})
